import { createLogic } from "redux-logic";
import firebase from "firebase/app";
import "firebase/firestore";

import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";
import { firebaseConfig } from "../../helpers/firebase/defaultFirebaseConfig";

const controlPanelInitLogic = createLogic({
	type: ActionTypes.CONTROL_PANEL_INIT,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase.initializeApp(firebaseConfig);
		const firestore = firebase.firestore();
		firestore.settings({ timestampsInSnapshots: true });
		dispatch(controlPanelActions.loadMetadata());
		dispatch(controlPanelActions.controlPanelInitComplete());
		done();
	},
});

export default [controlPanelInitLogic];
